export const ALL = '__all__';
const CLIENT = 'private-client';
const USER = 'private-user';

export const getClientChannel = clientId => `${CLIENT}-${clientId}`;
export const getUserChannel = userId => `${USER}-${userId}`;
